/**
 * 导航菜单项常量定义
 * @param {Function} activeClass - 根据路径slug返回激活样式的函数
 * @param {Object} s - 样式对象
 * @returns {Object} 包含各类菜单项的对象
 */
export const getMenuItems = (activeClass, s) => {
  // 温湿度产品子菜单项
  const temperatureItems = [
    // {
    //   path: '/temp-rh-monitor/overview',
    //   icon: s.goose,
    //   messageId: 'goose_lite',
    //   isActive: activeClass('temp-rh-monitor'),
    //   extraClass: s.limit_width
    // },
    {
      path: '/temp-rh-monitor-3t/overview',
      icon: s.goose,
      messageId: 'goose3t',
      isActive: activeClass('temp-rh-monitor-3t'),
      extraClass: s.limit_width,
      new: true
    },
    {
      path: '/temp-rh-monitor-3/overview',
      icon: s.goose,
      messageId: 'goose3_duck3',
      isActive: activeClass('temp-rh-monitor-3'),
      extraClass: s.limit_width,
      new: true
    },
    // {
    //   path: '/temp-rh-monitor-lite/overview',
    //   icon: s.duck2,
    //   messageId: 'duck2',
    //   isActive: activeClass('temp-rh-monitor-lite'),
    //   extraClass: s.limit_width
    // },
    {
      path: '/temp-rh-monitor-pro-s/overview',
      icon: s.lora,
      messageId: 'pheasant',
      isActive: activeClass('temp-rh-monitor-pro-s'),
      extraClass: s.limit_width
    },
    {
      path: '/multi-role-monitor/overview',
      icon: s.frog,
      messageId: 'frogs',
      isActive: activeClass('multi-role-monitor'),
      extraClass: s.limit_width,
      messageValues: { br: '' },
      new: true
    },
    {
      path: '/wall-socket-thermometer/overview',
      icon: s.gecko,
      messageId: 'gecko_name',
      isActive: activeClass('wall-socket-thermometer'),
      extraClass: s.limit_width
    },
    {
      path: '/lee-guitars-thermo-hygrometer/overview',
      icon: s.duck,
      messageId: 'magpie',
      isActive: activeClass('lee-guitars-thermo-hygrometer'),
      extraClass: s.limit_width,
      messageValues: { br: '' }
    },
    {
      path: '/comparison-temp-rh-monitor',
      icon: s.comparison,
      messageId: 'comparison',
      isActive: activeClass('comparison-temp-rh-monitor'),
    }
  ];
  
  // 时钟产品子菜单项
  const clockItems = [
    {
      path: '/bluetooth-alarm-clock/overview',
      icon: s.dove,
      messageId: 'dove',
      isActive: activeClass('bluetooth-alarm-clock'),
      customStyle: { paddingLeft: 30, paddingRight: 30 }
    },
    {
      path: '/bluetooth-clock/overview',
      icon: s.chicken,
      messageId: 'chicken',
      isActive: activeClass('bluetooth-clock'),
      customStyle: { paddingLeft: 30, paddingRight: 30 }
    }
  ];
  
  // 空气产品子菜单项
  const airItems = [
    {
      path: '/air-monitor-2/overview',
      icon: s.snow2,
      messageId: 'sw2',
      extraClass: s.limit_width,
      isActive: activeClass('air-monitor-2'),
      customStyle: { paddingLeft: 30, paddingRight: 30 }
    },
    {
      path: '/air-monitor-lite/overview',
      icon: s.dany,
      messageId: 'dany_name',
      isActive: activeClass('air-monitor-lite'),
      extraClass: s.limit_width,
      customStyle: { paddingLeft: 30, paddingRight: 30 }
    },
    {
      path: '/co2-temp-rh-monitor/overview',
      icon: s.lora,
      messageId: 'ph_co2_name_value',
      isActive: activeClass('co2-temp-rh-monitor'),
      extraClass: s.limit_width,
      customStyle: { paddingLeft: 30, paddingRight: 30 }
    },
    {
      path: '/indoor-environment-monitor/overview',
      icon: s.robb,
      messageId: 'robb',
      isActive: activeClass('robb'),
      extraClass: s.limit_width,
      messageValues: { br: '' },
      new: true
    },
    {
      path: '/comparison-air-monitor',
      icon: s.comparison,
      messageId: 'comparison',
      isActive: activeClass('comparison-air-monitor'),
    }
  ];
  
  // 传感器产品子菜单项
  const sensorItems = [
    {
      path: '/door-window-sensor/overview',
      icon: s.hodor,
      messageId: 'hodor_name',
      isActive: activeClass('door-window-sensor'),
      customStyle: { paddingLeft: 30, paddingRight: 30 },
      messageValues: { br: ' ' }
    },
    {
      path: '/motion-light-sensor/overview',
      icon: s.parrot,
      messageId: 'parrot_name',
      isActive: activeClass('motion-light-sensor'),
      customStyle: { paddingLeft: 30, paddingRight: 30 },
      messageValues: { br: ' ' }
    }
  ];

  return {
    temperatureItems,
    clockItems,
    airItems,
    sensorItems
  };
};
